import Button from "components/button/Button";
import Input from "components/formInput/Input";
import { useEffect, useState } from "react";
import "./styles.scss";

import i18n from "i18n";
import { ROUTE } from "routes/route";

import { EMAIL_REGEX } from "constants/regex";
import { apiSendCodeDelete, apiSendEmailDelete } from "helpers/api/accounts";
import { showToastError } from "utils";

const ScreenStep = {
  inputEmail: "Step-1",
  inputCode: "Setp-2",
  deleteSuccess: "Setp-3",
};

const DeleteAccount = () => {
  const searchParams = new URLSearchParams(window.location.search);

  const isExpired = searchParams.get("isExpired");

  useEffect(() => {
    if (isExpired) {
      showToastError("messages.MSG-USP086");
      window.history.replaceState(
        {},
        document.title,
        ROUTE.PUBLIC.RESET_PASSWORD
      );
      setStep(ScreenStep.inputEmail);
    }
  }, [isExpired]);

  const [step, setStep] = useState(ScreenStep.inputEmail);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [isValidEmail, setIsvalidEmail] = useState(true);
  const [isValidCode, setIsvalidCode] = useState(true);

  const handleChangeEmail = (event) => {
    const { value } = event.target;
    const regex = new RegExp(EMAIL_REGEX, 'g');
    if (value?.match(regex)) {
      setEmail(value);
      setIsvalidEmail(true);
    } else {
      setIsvalidEmail(false);
    }
  };

  const onClickConfirmEmail = () => {
    apiSendEmailDelete(email)
      .then((resp) => {
        if (resp?.data?.message) {
          if (step !== ScreenStep.inputCode) {
            setStep(ScreenStep.inputCode);
          }
        } else {
          showToastError('アカウントが見つかりませんでした。');
        }
      })
      .catch((err) => {
        showToastError(err.message);
      });
  };

  const onGetCode = () => {
    onClickConfirmEmail();
  };

  const onClickSendCode = () => {
    apiSendCodeDelete(code)
      .then((resp) => {
        if (resp?.data?.message) {
          setStep(ScreenStep.deleteSuccess);
        } else {
          setIsvalidCode(false);
        }
      })
      .catch((err) => {
        setIsvalidCode(false);
        showToastError(err.message);
      });
  };

  return (
    <div className="main-content">
      {step !== ScreenStep.deleteSuccess && (
        <div className="header-left">アカウント削除</div>
      )}
      {step === ScreenStep.inputEmail && (
        <div className="delete-account-container">
          <div className="card-content">
            <div className="card-title">
              <div>アカウント削除を行うために、登録済みのメールアドレスをご入力の上、</div>
              <div>認証手続きを行ってください。</div>
            </div>
            <Input
              placeholder={"メールアドレスを入力してください。"}
              name="email"
              onChange={handleChangeEmail}
              type="email"
              error={!isValidEmail ? i18n.t("messages.MSG-USP001") : ""}
            />

            <Button
              style={{
                fontSize: 20,
                fontWeight: 900,
                borderRadius: 60,
                marginTop: 50,
              }}
              text={"送信"}
              width={500}
              height={40}
              disabled={!email}
              onClick={() => onClickConfirmEmail()}
            />
          </div>
        </div>
      )}

      {step === ScreenStep.inputCode && (
        <div className="delete-account-container">
          <div className="card-content">
            <Input
              placeholder={"認証用コードを入力してください"}
              name="code"
              onChange={(e) => {
                setCode(e.target.value)
                setIsvalidCode(true)
              }}
              // type="numberString"
              error={!isValidCode ? <>
              <div>※認証コードが間違っています。</div>
              <div>再送信して新しいコード入れるか、有効期限以内に再度入力してください。</div>
              </> : ""}
            />

            <Button
              style={{
                fontSize: 20,
                fontWeight: 900,
                borderRadius: 60,
                marginTop: 50,
              }}
              text={"認証する"}
              width={500}
              height={40}
              disabled={!code}
              onClick={() => onClickSendCode()}
            />
            <div className="text-link" onClick={onGetCode}>
              認証コードを再取得する
            </div>
          </div>
        </div>
      )}

      {step === ScreenStep.deleteSuccess && (
        <div className="delete-account-container">
          <div className="card-content">
            このアカウントに関連するデータは全て削除されました。
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAccount;
